import request from '@/utils/request'

export function getHouseList(data) {
  return request({
    url: `/api/v3/asset/house/list`,
    method: 'post',
    data
  })
}

export function getHouseDetail(id) {
  return request({
    url: `/api/v3/asset/house/detail/${id}`
  })
}

export function delHouse(ids) {
  return request({
    url: `/api/v3/asset/house/delete`,
    method: 'DELETE',
    data: ids
  })
}

// 新增
export function addHouse(obj) {
  return request({
    url: '/api/v3/asset/house/create',
    method: 'post',
    data: obj
  })
}

// 修改
export function updateHouse(obj) {
  return request({
    url: '/api/v3/asset/house/update',
    method: 'POST',
    data: obj
  })
}

// *房屋产权转移
export function transferHouse(data) {
  return request({
    url: '/api/v3/asset/house/transfer',
    method: 'POST',
    data
  })
}

// *房屋导出
export function houseExcelExport(data) {
  return request({
    url: '/api/v3/asset/house/excelExport',
    method: 'POST',
    data
  })
}

